module.exports = __webpack_public_path__ + "static/img/3-1.72e747f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/3-1.png
// module id = 6zm2
// module chunks = 0